const localStorageWorker = {
  isSupportLocalStorage:
    typeof localStorage !== 'undefined' && localStorage !== null,
  set(key: string, item: string) {
    if (this.isSupportLocalStorage) {
      localStorage.setItem(key, item);
    }
  },
  get(key: string) {
    if (this.isSupportLocalStorage) {
      const item = localStorage.getItem(key);
      return item;
    } else {
      return null;
    }
  },
  remove(key: string) {
    if (this.isSupportLocalStorage) {
      localStorage.removeItem(key);
    }
  },
  clear() {
    if (this.isSupportLocalStorage) {
      localStorage.clear();
    }
  },
};

export { localStorageWorker };
